import React, { useState } from 'react';
import Modal from '../../../../component/modal/Modal';
import InputField from '../../../../component/form/FormInput';
import InputSelect from '../../../../component/inputSelect/InputSelect';
import { getCurrentDate } from '../../../../utils/dateUtils';
import { generateArray } from '../../../../utils/constant';

export default function ScheduleReportModal({
	isScheduleModelOpen,
	setIsScheduleModelOpen,
	activeTab,
	scheduleParams,
	setScheduleParams,
	loaderScheduleReport,
}) {
	const [error, setError] = useState({});
	const frequencyList = [
		{ key: 'Weekly', value: 'Weekly' },
		{ key: 'Monthly', value: 'Monthly' },
		{ key: 'Yearly', value: 'Yearly' },
	];
	const reciepientList = [
		{ key: 'Mohd Hasir', value: 'Mohd Hasir' },
		{ key: 'Mohammad Aasif', value: 'Mohammad Aasif' },
		{ key: 'Mohd Shabaj', value: 'Mohd Shabaj' },
		{ key: 'Arjit Singh', value: 'Arjit Singh' },
	];
	const getHoursList = generateArray(24);
	const getMinutesList = generateArray(60);
	const handleSaveScheduleReport = () => {};

	const handleFormData = (key, value, inputType, required = false) => {
		setScheduleParams((prev) => ({
			...prev,
			[key]: value,
		}));
		let newError = { ...error };
		if (required) {
			if (value !== '' && value !== undefined && value !== null) {
				delete newError[key];
			} else {
				newError[key] =
					inputType === 'field'
						? `Please enter ${key.replaceAll('_', ' ')} in the field.`
						: `Please select a valid ${key.replaceAll('_', ' ')} from the list.`;
			}
		}
		setError(newError);
	};

	return (
		<div>
			<Modal
				className="schedule_report_modal"
				title={`Schedule Report`}
				isOpen={isScheduleModelOpen}
				actionButton={loaderScheduleReport ? null : isScheduleModelOpen}
				handleSave={() => {
					handleSaveScheduleReport();
				}}
				onClose={() => {
					setIsScheduleModelOpen(false);
				}}
				cancelButton={() => {
					setIsScheduleModelOpen(false);
				}}
			>
				<div>
					<div className="d-flex gap-2 align-items-center">
						Report Name : <b>{activeTab}</b>
					</div>
					<div className="d-flex align-items-center gap-4 py-3">
						<div className="col-3">
							<InputSelect
								options={frequencyList}
								label="Frequency"
								placeholder="Frequency"
								required={true}
								autoComplete="off"
								disabled={false}
								returnInputValue={false}
								value={scheduleParams.frequency_name}
								onChange={(value) => {
									if (value === '') {
										handleFormData('frequency_name', value, 'select', true);
									}
								}}
								onSelect={(option) => handleFormData('frequency_name', option.key, 'select', true)}
								error={error?.frequency_name}
							/>
						</div>
						<div
							className="fs-4 fw-light"
							style={{ paddingTop: '15px' }}
						>
							Report will be generated and sent on a weekly basis.
						</div>
					</div>
					<div className="row">
						<div className="col-6">
							<InputField
								label="Start Date"
								placeholder="Enter Date"
								type="date"
								autoComplete="off"
								required={true}
								error={error?.start_date}
								// autoFocus={isDateFocus}
								value={scheduleParams.start_date}
								onChange={(value) => handleFormData('start_date', value, 'field', true)}
								max={getCurrentDate()}
							/>
						</div>
						<div className="col-3">
							<InputSelect
								options={getHoursList}
								label="Hours"
								placeholder="Hours"
								required={true}
								autoComplete="off"
								disabled={false}
								returnInputValue={false}
								value={scheduleParams.hours}
								onChange={(value) => {
									if (value === '') {
										handleFormData('hours', value, 'select', true);
									}
								}}
								onSelect={(option) => handleFormData('hours', option.key, 'select', true)}
								error={error?.hours}
							/>
						</div>
						<div className="col-3">
							<InputSelect
								options={getMinutesList}
								label="Minutes"
								placeholder="Minutes"
								required={true}
								autoComplete="off"
								disabled={false}
								returnInputValue={false}
								value={scheduleParams.minutes}
								onChange={(value) => {
									if (value === '') {
										handleFormData('minutes', value, 'select', true);
									}
								}}
								onSelect={(option) => handleFormData('minutes', option.key, 'select', true)}
								error={error?.minutes}
							/>
						</div>
					</div>
					<div className="fs-3 fw-bold text-dark">Receipient Details</div>
					<div className="col-5 py-3">
						<InputSelect
							options={reciepientList}
							label="Email Reciepient"
							placeholder="Email Reciepient"
							required={true}
							autoComplete="off"
							disabled={false}
							returnInputValue={false}
							value={scheduleParams.email_reciepient}
							onChange={(value) => {
								if (value === '') {
									handleFormData('email_reciepient', value, 'select', true);
								}
							}}
							onSelect={(option) => handleFormData('email_reciepient', option.key, 'select', true)}
							error={error?.email_reciepient}
							onAddNew={() => {}}
						/>
					</div>
					<InputField
						type="text"
						value={scheduleParams?.customer_notes}
						placeholder=""
						label="Additional Reciepent"
						multiline={true}
						rows={3}
						onChange={(value) => handleFormData('customer_notes', value, 'field')}
						autoComplete="new-customer-notes"
					/>
					<div className="fs-5 fw-light">Use comma(,) to separate more than one email address.</div>
					<div className="d-flex py-3">
						<div className="fs-4 fw-light py-2">Attach Report As</div>
						<div className="fs-4 fw-light text-danger">*</div>
					</div>
					<div className="d-flex gap-4 align-items-center py-2">
						<label className="d-flex gap-3 py-2 cursor-pointer">
							<input
								type="radio"
								className="custom-radio"
								name="pdf"
								checked={scheduleParams.pdf}
								onChange={(e) => {
									setScheduleParams((prev) => ({
										...prev,
										pdf: e.target.checked,
									}));
								}}
							/>
							PDF
						</label>
						<label className="d-flex gap-3 cursor-pointer">
							<input
								type="radio"
								name="csv"
								className="custom-radio"
								checked={scheduleParams.csv}
								onChange={(e) => {
									setScheduleParams((prev) => ({
										...prev,
										csv: e.target.checked,
									}));
								}}
							/>
							CSV (Comma Separated Value)
						</label>
						<label className="d-flex gap-3 py-2 cursor-pointer">
							<input
								type="radio"
								name="xls"
								className="custom-radio"
								checked={scheduleParams.xls}
								onChange={(e) => {
									setScheduleParams((prev) => ({
										...prev,
										xls: e.target.checked,
									}));
								}}
							/>
							XLS (Microsoft Excel 1997-2004 Compatible)
						</label>
					</div>
					<div className="d-flex gap-2 align-items-center py-4">
						<b>Notes:</b> The Generated report will contain only a maximum of 2000 records
					</div>
				</div>
			</Modal>
		</div>
	);
}
